"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const CachingDataService_1 = __importStar(require("../../services/data/CachingDataService"));
const blobFunctions_1 = require("../../utils/blobFunctions");
const Image_1 = __importDefault(require("../shared/Image"));
const Video_1 = __importDefault(require("../shared/Video"));
exports.default = react_1.default.memo(MediaContent);
function MediaContent(props) {
    const content = props.content;
    const ownedBlobUrl = props.ownsBlob ? content.blobUrl : null;
    const unmounted = react_1.useRef(false);
    const loaded = react_1.useRef(false);
    const src = react_1.useRef(ownedBlobUrl !== null && ownedBlobUrl !== void 0 ? ownedBlobUrl : content.thumbnailData);
    // https://reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [_, forceUpdate] = react_1.useReducer(x => x + 1, 0);
    react_1.useLayoutEffect(() => {
        return () => {
            unmounted.current = true;
        };
    }, []);
    react_1.useEffect(() => {
        function fetchMedia() {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield CachingDataService_1.default.getData(CachingDataService_1.DataSource.MediaMessage, content.id, content.size, content.chunkSize);
                if (response.kind !== "success") {
                    console.log(response);
                    return;
                }
                if (!unmounted.current) {
                    src.current = blobFunctions_1.dataToBlobUrl(response.data, content.mimeType);
                    loaded.current = true;
                    forceUpdate();
                }
            });
        }
        if (!ownedBlobUrl && !props.content.blobDeleted) {
            fetchMedia();
        }
        return () => {
            // Dispose of blob
            if (loaded.current) {
                setTimeout(() => {
                    URL.revokeObjectURL(src.current);
                }, 100);
            }
        };
    }, []);
    let contentElement;
    if (content.mimeType.startsWith("image/") || (!loaded.current && !ownedBlobUrl)) {
        contentElement = react_1.default.createElement(Image_1.default, { key: props.content.id, src: src.current, className: props.className });
    }
    else if (content.mimeType.startsWith("video/")) {
        contentElement = react_1.default.createElement(Video_1.default, { key: props.content.id, src: src.current, className: props.className });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, contentElement));
}
